/** Whether outbound "Call Me" (callback) is configured for the project phone agent. */
export function isCallMePhoneProvisioned(
  agent:
    | {
        phoneProvider?: string | null;
        agentPhoneAgentId?: string | null;
        agentPhoneNumberId?: string | null;
        phoneNumber?: string | null;
        isProvisioned?: boolean;
        vapiAiPhoneId?: string | null;
        assistantId?: string | null;
      }
    | null
    | undefined,
): boolean {
  if (!agent) return false;
  const phone = agent.phoneNumber?.trim();
  if (!phone) return false;

  const provider = String(agent.phoneProvider ?? "vapi").toLowerCase();
  if (provider === "agentphone") {
    return (
      !!agent.agentPhoneAgentId?.trim() &&
      !!agent.agentPhoneNumberId?.trim()
    );
  }

  return (
    agent.isProvisioned === true &&
    !!(agent.vapiAiPhoneId?.trim() || agent.assistantId?.trim())
  );
}

/** Whether outbound "Text Me" (SMS) is configured for the project. */
export function isSmsProvisioned(
  agent:
    | {
        agentPhoneSmsAgentId?: string | null;
        agentPhoneSmsNumberId?: string | null;
        smsPhoneNumber?: string | null;
        phoneProvider?: string | null;
      }
    | null
    | undefined,
): boolean {
  if (!agent) return false;
  if (String(agent.phoneProvider ?? "vapi").toLowerCase() !== "agentphone") {
    return false;
  }
  return (
    !!agent.agentPhoneSmsAgentId?.trim() &&
    !!agent.agentPhoneSmsNumberId?.trim() &&
    !!agent.smsPhoneNumber?.trim()
  );
}
